module.exports = __webpack_public_path__ + "img/nocoupon.945e1650.svg";